import {
  GET_USER_PROFILE,
  USER_PROFILE_SUCCESS,
  USER_ENTITIES,
  USER_ENTITIES_SAVE,
  USER_MODULES,
  USER_MODULES_SAVE,
  USER_DATE,
  USER_DATE_SAVE,
  SESSION_TIMEOUT,
} from '../types/actionTypes';

export const getProfile = () => ({
  type: GET_USER_PROFILE,
});

export const userProfileSuccess = (userinfo) => ({
  type: USER_PROFILE_SUCCESS,
  payload: { userinfo },
});

export const userEntitiesSave = (entities) => ({
  type: USER_ENTITIES_SAVE,
  payload: { entities },
});

export const userEntities = (entities) => ({
  type: USER_ENTITIES,
  payload: { entities },
});

export const userDate = (date) => ({
  type: USER_DATE,
  payload: { date },
});

export const userDateSave = (date) => ({
  type: USER_DATE_SAVE,
  payload: { date },
});

export const userModulesSave = (modules) => ({
  type: USER_MODULES_SAVE,
  payload: { modules },
});

export const userModules = (modules) => ({
  type: USER_MODULES,
  payload: { modules },
});

export const sessionTimeout = () => ({
  type: SESSION_TIMEOUT
});
